// @mui
import { SvgIcon } from "@mui/material";

function ArrowDownIcon(props) {
  const { sx } = props;
  return (
    <SvgIcon
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      sx={{
        "& g": {
          stroke: (theme) => theme.palette.grey.g3,
        },
        ...sx,
      }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Iconly/Light/Arrow---Down-2"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Arrow---Down-2"
          transform="translate(5.000000, 8.500000)"
          stroke={props.color || "#000000"}
          strokeWidth="1.5"
        >
          <polyline id="Stroke-1" points="14 0 7 7 0 0"></polyline>
        </g>
      </g>
    </SvgIcon>
  );
}

export default ArrowDownIcon;
